import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  Col,
  Form,
  Select,
  Input,
  Space,
  Spin,
  Radio,
  message,
  DatePicker,
  Tooltip,
  Modal
} from 'antd';
import styles from '@/common/Layout/index.module.less';
import { useDispatch } from 'react-redux';
import {
  getProductBatches,
  getProcesses,
  createProducts,
  getProducts,
  downloadpdf,
  verifyBatch,
  regenerateProdLabelPdf
} from '../redux/slice';
import { getBalance } from '@/features/dispensing/redux/slice';
import { getAllDispenseBooths } from '@/features/dispensing/redux/slice';
import Layout from '@/common/Layout';
import FormItem from '@/common/FormItem';
import CustomButton from '@/common/CustomButton';
import { getLoggedInUser } from 'utilities/helpers';
import moment from 'moment';
import {
  CloudDownloadOutlined,
  EditOutlined,
  QrcodeOutlined
} from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import { QrReader } from 'react-qr-reader';
import VerificationModal from '@/features/material/components/VerificationModal';
import { compute_gross_weight } from './weights.helper';
const CreateProductLabel = () => {
  const [form, form1] = Form.useForm();
  const dispatch = useDispatch();
  const [productsData, setProductsData] = useState([]);
  const [search, setSearch] = useState('');
  const [processes, setProcesses] = useState([]);
  // const [processDetails, setProcessDetails] = useState([]);
  const [data, setData] = useState();
  const [showNextCard, setShowNextCard] = useState(false);
  const [dispenseBooths, setDispenseBooths] = useState([]);
  const [netWeight, setNetWeight] = useState();
  const [tareWeight, setTareWeight] = useState();
  const [genPdfs, setGenPdfs] = useState([]);
  const [prodLabelsDetails, setProdLabelsDetails] = useState([
    { container_id: '', tare_wt: '', net_Wt: '', gross_weight: '' }
  ]);
  const [prodLabels, setProdLabels] = useState([]);
  const [dataId, setDataId] = useState();
  const [containerId, setContainerId] = useState('');
  const [submittingContainerId, setSubmittingContainerId] = useState(null);
  const [editingContainer, setEditingContainer] = useState(null);
  const [editWeights, setEditWeights] = useState({
    tareWeight: '',
    netWeight: ''
  });
  const [stageData, setStageData] = useState([]);
  const [nextStageData, setNextStageData] = useState([]);
  const [isCompression, setIsCompression] = useState('');
  const [showSubimt, setShowSubimt] = useState(false);
  const [ipAddress, setIpAddress] = useState('');
  const [portID, setPortID] = useState('');
  const [openCam, setOpenCam] = useState(false);
  const [balancetype, setBalanceType] = useState('');
  const [isHeaderEdit, setIsHeaderEdit] = useState(false);
  const [isQAModal, setIsQAModal] = useState(false);
  const [pendingHeaderUpdate, setPendingHeaderUpdate] = useState(null);
  const [originalHeaderValues, setOriginalHeaderValues] = useState(null);
  const [isHeaderDirty, setIsHeaderDirty] = useState(false);
  const [regeneratingLabelId, setRegeneratingLabelId] = useState(null);
  const [isWeightQAModal, setIsWeightQAModal] = useState(false);
  const [pendingWeightUpdate, setPendingWeightUpdate] = useState(null);

  const { user } = getLoggedInUser();
  const searchdata = useLocation().search;
  const params = new URLSearchParams(searchdata);
  useEffect(() => {
    handleGetProductBatches();
    handleGetProcessGroups();
    handleGetStageGroups();
    handleGetDispenseBooths();
    handleGetNextStageGroups();

    // handleGetProductLabels();
  }, [search]);

  console.log(setProdLabelsDetails, prodLabelsDetails);
  useEffect(() => {
    handleGetProductLabelsById();
  }, [genPdfs]);

  const handleGetProductBatches = () => {
    const payload = { search };
    dispatch(getProductBatches(payload)).then((res) => {
      if (res.payload.success) {
        setProductsData(res.payload.data);
      }
    });
  };

  // const handleGetProductLabels = () => {
  //   const payload = { search };
  //   dispatch(getProductBatches(payload)).then((res) => {
  //     if (res.payload.success) {
  //       setProductsData(res.payload.data);
  //     }
  //   });
  // };

  const handleError = (err) => {
    console.error(err);
  };

  const handleQrScan = async (scanData) => {
    if (scanData && scanData !== '') {
      console.log(scanData.text);
      let booth_details = dispenseBooths.filter(
        (item) => item?.ip_address == scanData.text
      );
      setIpAddress(scanData.text);
      setPortID(booth_details?.[0]?.port);
      setBalanceType(booth_details?.[0]?.type);
      setOpenCam(false);
    } else {
      console.log('asdasd');
    }
  };

  console.log(ipAddress);
  console.log(portID);
  const handleGetProcessGroups = () => {
    const payload = { type: 'process', search };
    dispatch(getProcesses(payload)).then((res) => {
      if (res.payload.success) {
        setProcesses(res.payload.data);
      }
    });
  };

  const handleGetStageGroups = () => {
    const payload = { type: 'stage', search };
    dispatch(getProcesses(payload)).then((res) => {
      if (res.payload.success) {
        setStageData(res.payload.data);
      }
    });
  };

  const handleGetNextStageGroups = () => {
    const payload = { type: 'nextStage', search };
    dispatch(getProcesses(payload)).then((res) => {
      if (res.payload.success) {
        setNextStageData(res.payload.data);
      }
    });
  };

  const handleGetDispenseBooths = () => {
    dispatch(getAllDispenseBooths()).then((result) => {
      if (result?.payload?.success) {
        setDispenseBooths(result?.payload?.data);
      }
    });
  };

  const handleGetProductLabelsById = () => {
    const payload = { id: data?.id || params.get('id') };
    dispatch(getProducts(payload)).then((result) => {
      if (result?.payload?.success) {
        setProdLabels(result?.payload?.data?.[0]?.prod_dispensing_labels);
        setIsCompression(result?.payload?.data?.[0]?.is_compressed);
        params.get('id') &&
          form.setFieldsValue({
            product_batch: result?.payload?.data?.[0]?.batch_no,
            is_compressed: result?.payload?.data?.[0]?.is_compressed
              ? 'yes'
              : 'no',
            dispensing_request_id: result?.payload?.data?.[0]?.batch_no,
            product_name: result?.payload?.data?.[0]?.is_compressed
              ? result?.payload?.data?.[0]?.product_name
              : result?.payload?.data?.[0]?.product_detail?.name,
            prodlabel_process_id:
              result?.payload?.data?.[0]?.prod_label_process_master?.id,
            prodlabel_stage_id:
              result?.payload?.data?.[0]?.prod_label_stage_master?.id,
            prodlabel_nextstage_id:
              result?.payload?.data?.[0]?.prodlabel_nextstage_master?.id,
            bom_process_id: result?.payload?.data?.[0]?.bom_process_master?.id,
            no_of_containers: result?.payload?.data?.[0]?.no_of_containers,
            hold_time:
              result?.payload?.data?.[0]?.hold_time &&
              moment(result?.payload?.data?.[0]?.hold_time).isValid()
                ? moment(result?.payload?.data?.[0]?.hold_time)
                : null,
            batch_size:
              result?.payload?.data?.[0]?.product_detail
                ?.theoretical_batch_size,
            lot_no:
              result?.payload?.data?.[0]?.lot_no === '0'
                ? 'NA'
                : `Lot ${result?.payload?.data?.[0]?.lot_no}`
          });
        setDataId(result.payload.data);
        setShowNextCard(true);
      }
    });
  };

  const onFinish = (values) => {
    console.log('Success:', values);
    values['is_compressed'] = values.is_compressed === 'yes' ? true : false;
    dispatch(createProducts(values)).then((res) => {
      if (res.payload.success) {
        form.setFieldsValue({
          dispensing_request_id: values?.dispensing_request_id,
          product_name: values?.product_name,
          bom_process_group_id: values.bom_process_group_id,
          bom_process_id: values.bom_process_id,
          no_of_containers: values.no_of_containers,
          batch_size: values?.batch_size
        });
        setData(res.payload.dispensingRecord);
        setShowNextCard(true);
      }
    });
  };

  const onFinish1 = (values) => {
    console.log('Success:', data);
    // Track which container is being submitted - use containerId if set, otherwise 'new' for new row
    const currentContainerId =
      containerId || (editingContainer ? editingContainer : 'new');
    setSubmittingContainerId(currentContainerId);

    if (containerId !== '') {
      values['dispense_label_id'] = containerId;
      values['id'] = params.get('id');
    } else {
      values['id'] = data?.id || params.get('id');
    }

    // Use edit weights if in edit mode, otherwise use global state
    const finalTareWeight = editingContainer
      ? editWeights.tareWeight
      : tareWeight;
    const finalNetWeight = editingContainer ? editWeights.netWeight : netWeight;

    values['net_Wt'] = finalNetWeight;
    values['tare_Wt'] = finalTareWeight;
    values['gross_weight'] = compute_gross_weight(
      finalTareWeight,
      finalNetWeight
    );
    values['weighing_balance'] = params.get('id')
      ? prodLabels?.[0]?.weighing_balance
      : ipAddress;
    dispatch(createProducts(values))
      .then((res) => {
        if (res.payload.success) {
          setSubmittingContainerId(null);
          setGenPdfs([...genPdfs, { pdf: res.payload.data }]);
          setTareWeight('');
          setNetWeight('');
          setEditWeights({ tareWeight: '', netWeight: '' });
          setEditingContainer(null);
          setContainerId('');
          console.log('Success:', res.payload.data);
        } else {
          // Reset on error too
          setSubmittingContainerId(null);
        }
      })
      .catch(() => {
        // Reset on error
        setSubmittingContainerId(null);
      });
  };
  const onSearch = (e) => {
    console.log(e);
    setSearch(e);
  };

  // const handleChange = (e) => {
  //   const processes = processGroups.filter((process) => process.id === e);
  //   setProcessDetails(processes?.[0]?.bom_process_masters);
  // };

  const onChange = (e) => {
    const product_name = productsData?.filter((product) => product.id === e);
    console.log(product_name);
    form?.setFieldsValue({
      product_name: product_name?.[0]?.product_detail?.name,
      batch_size: product_name?.[0]?.product_detail?.theoretical_batch_size
    });
  };

  const onChangeLabel = (e) => {
    console.log(e);
    form.resetFields();
    form.setFieldsValue({ is_compressed: e.target.value });
    setIsCompression(e.target.value === 'yes' ? true : false);
  };
  // const onChangeprocess = (e) => {
  // const process = processes?.filter((process) => process.id === e);
  // console.log(process, 'process');
  // setStageData(process?.[0]?.prod_label_stage_masters);
  // };

  // const onChangestage = (e) => {
  // const stage = stageData?.filter((process) => process.id === e);
  // setNextStageData(stage?.[0]?.prodlabel_nextstage_masters);
  // };

  const handleEdit = (id) => {
    const item = prodLabels.find((item) => item.id === id);
    if (item) {
      setEditingContainer(id);
      setContainerId(id);
      setEditWeights({
        tareWeight: item.tare_Wt || '',
        netWeight: item.net_Wt || ''
      });
      // Clear global state to prevent interference with new row
      setTareWeight('');
      setNetWeight('');
    }
  };
  // const handleChangeWeight = (e, type) => {
  //   const list = [...productsData];
  //   list[type] = e.target.value;
  //   setProductsData(list);
  // };

  const weighing_balance_id = params.get('id')
    ? dispenseBooths?.filter(
        (item) => item.ip_address === prodLabels?.[0]?.weighing_balance
      )
    : ipAddress
    ? dispenseBooths?.filter((item) => item.ip_address === ipAddress)
    : '';
  console.log(weighing_balance_id);
  const handleDownloadPdf = (id) => {
    const payload = { id };
    dispatch(downloadpdf(payload)).then((res) => {
      if (res?.payload?.success) {
        // window.open(res?.payload?.data, '_blank');
        window.open(
          `${process.env.REACT_APP_STORAGE_URL}${res?.payload?.data
            .split('/')
            .pop()}`,
          '_blank'
        );
      }
    });
  };

  const handleVerify = () => {
    const payload = {
      product_batch: form.getFieldValue('product_batch')
    };
    dispatch(verifyBatch(payload)).then((res) => {
      if (res?.payload?.success) {
        message.success(res?.payload?.message);
        setShowSubimt(true);
      } else {
        message.error(res?.payload?.message);
        setShowSubimt(false);
      }
    });
  };

  const handleDispenseBooth = (weight_type, containerId = null) => {
    const payload = { ip: ipAddress, type: balancetype, port: portID };
    dispatch(getBalance(payload)).then((response) => {
      if (response?.payload?.success) {
        if (weight_type == 'tare_weight') {
          setTareWeight(response?.payload?.data);
          if (containerId && editingContainer === containerId) {
            setEditWeights((prev) => ({
              ...prev,
              tareWeight: response?.payload?.data
            }));
          }
        } else {
          setNetWeight(response?.payload?.data);
          if (containerId && editingContainer === containerId) {
            setEditWeights((prev) => ({
              ...prev,
              netWeight: response?.payload?.data
            }));
          }
        }
      }
    });
  };

  const handleRegenerateLabelPdf = (labelId) => {
    if (!labelId) return;
    setRegeneratingLabelId(labelId);
    dispatch(regenerateProdLabelPdf({ id: labelId }))
      .then((res) => {
        if (res?.payload?.success && res?.payload?.data) {
          const filename = res.payload.data.split('/').pop();
          window.open(
            `${process.env.REACT_APP_STORAGE_URL}${filename}`,
            '_blank'
          );
        } else {
          message.error(
            res?.payload?.message || 'Failed to regenerate label PDF'
          );
        }
      })
      .finally(() => setRegeneratingLabelId(null));
  };

  const handleInitiateWeightQA = (labelId) => {
    if (!labelId) return;
    if (!editWeights.tareWeight || !editWeights.netWeight) {
      message.error('Enter both Tare Weight and Net Weight');
      return;
    }
    setPendingWeightUpdate({
      id: Number(params.get('id')),
      dispense_label_id: labelId,
      tare_Wt: String(editWeights.tareWeight),
      net_Wt: String(editWeights.netWeight),
      gross_weight: compute_gross_weight(
        editWeights.tareWeight,
        editWeights.netWeight
      )
    });
    setIsWeightQAModal(true);
  };

  const normalizeHeaderValues = (vals) => ({
    prodlabel_nextstage_id: vals?.prodlabel_nextstage_id ?? null,
    hold_time:
      vals?.hold_time && moment.isMoment(vals.hold_time)
        ? vals.hold_time.format('YYYY-MM-DD')
        : vals?.hold_time ?? null,
    lot_no:
      vals?.lot_no === undefined || vals?.lot_no === null
        ? null
        : String(vals.lot_no)
  });

  const recomputeHeaderDirty = () => {
    if (!originalHeaderValues) {
      setIsHeaderDirty(false);
      return;
    }
    const current = form.getFieldsValue([
      'prodlabel_nextstage_id',
      'hold_time',
      'lot_no'
    ]);
    setIsHeaderDirty(
      JSON.stringify(normalizeHeaderValues(current)) !==
        JSON.stringify(normalizeHeaderValues(originalHeaderValues))
    );
  };

  const handleEnterHeaderEdit = () => {
    const snapshot = form.getFieldsValue([
      'prodlabel_nextstage_id',
      'hold_time',
      'lot_no'
    ]);
    setOriginalHeaderValues(snapshot);
    setIsHeaderDirty(false);
    setIsHeaderEdit(true);
  };

  const handleHeaderValuesChange = (changedValues) => {
    if (!isHeaderEdit) return;
    const watched = ['prodlabel_nextstage_id', 'hold_time', 'lot_no'];
    const touched = Object.keys(changedValues).some((k) => watched.includes(k));
    if (!touched) return;
    recomputeHeaderDirty();
  };

  const handleCancelHeaderEdit = () => {
    setIsHeaderEdit(false);
    setIsHeaderDirty(false);
    setOriginalHeaderValues(null);
    handleGetProductLabelsById();
  };

  const handleInitiateHeaderVerification = () => {
    form
      .validateFields(['prodlabel_nextstage_id', 'hold_time', 'lot_no'])
      .then((vals) => {
        const lotRaw = vals?.lot_no;
        const lotNoOut =
          lotRaw === 0 || lotRaw === '0' ? 'N/A' : String(lotRaw);
        setPendingHeaderUpdate({
          id: Number(params.get('id')),
          prodlabel_nextstage_id: vals?.prodlabel_nextstage_id,
          hold_time: vals?.hold_time
            ? moment(vals.hold_time).format('YYYY-MM-DD')
            : null,
          lot_no: lotNoOut
        });
        setIsQAModal(true);
      })
      .catch(() => {});
  };

  const handleBalance = (e) => {
    let booth_details = dispenseBooths.filter((item) => item?.ip_address == e);
    setIpAddress(e);
    setPortID(booth_details?.[0]?.port);
    setBalanceType(booth_details?.[0]?.type);
  };
  console.log(prodLabels);
  return (
    <>
      <Layout sider={false}>
        <Card
          title="Product Details"
          className={`${styles.cardStyles_approver}`}
          extra={
            params.get('id') && !isHeaderEdit ? (
              <Tooltip title="Edit Product Details">
                <CustomButton
                  className={styles.inwardButton}
                  type="primary"
                  size="small"
                  onClick={handleEnterHeaderEdit}
                >
                  <EditOutlined /> Edit
                </CustomButton>
              </Tooltip>
            ) : null
          }
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onValuesChange={handleHeaderValuesChange}
          >
            <Row gutter={24}>
              <Col span={8}>
                <FormItem
                  label="Is this label for Compression?"
                  name="is_compressed"
                  rules={[
                    {
                      required: true,
                      message: 'Select lable'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Radio.Group
                    onChange={onChangeLabel}
                    disabled={params.get('id')}
                  >
                    <Radio value="yes">Yes</Radio>
                    <Radio value="no">No</Radio>
                  </Radio.Group>
                </FormItem>
              </Col>
            </Row>

            <Row gutter={24}>
              {isCompression === false ? (
                <>
                  <Col span={8}>
                    <FormItem
                      label="Product Batch #"
                      name="dispensing_request_id"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        placeholder="Select Product Batch"
                        showSearch
                        optionFilterProp="children"
                        onChange={onChange}
                        onSearch={onSearch}
                        disabled={params.get('id') ? dataId : data}
                      >
                        {productsData?.map((category, index) => {
                          return (
                            <option value={category?.id} key={index}>
                              {category?.product_batch_number}
                            </option>
                          );
                        })}
                      </Select>
                    </FormItem>
                  </Col>
                  <Col span={16}>
                    <FormItem
                      label="Product name"
                      name="product_name"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product name'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder=""
                        value=""
                        // disabled={params.get('id') ? dataId : data}
                        disabled
                      />
                    </FormItem>
                  </Col>
                </>
              ) : (
                isCompression === true && (
                  <>
                    <Col span={8}>
                      <FormItem
                        label="Product Batch #"
                        name="product_batch"
                        rules={[
                          {
                            required: true,
                            message: 'Select Product Batch'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Input
                          placeholder=""
                          value=""
                          disabled={params.get('id')}
                          // disabled
                        />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        label="Product name"
                        name="product_name"
                        rules={[
                          {
                            required: true,
                            message: 'Select Product name'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Input
                          placeholder=""
                          value=""
                          disabled={params.get('id')}
                          // disabled
                        />
                      </FormItem>
                    </Col>
                    <Col span={4}>
                      <CustomButton
                        type="primary"
                        onClick={handleVerify}
                        disabled={params.get('id')}
                        className={styles.buttons}
                      >
                        Verify Batch
                      </CustomButton>
                    </Col>
                  </>
                )
              )}
              {/* <Col span={8}>
                <FormItem
                  label="Process Group"
                  name="bom_process_group_id"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Process group"
                    onChange={(e) => handleChange(e)}
                    disabled={params.get('id') ? dataId : data}
                  >
                    {processGroups?.map((category, index) => {
                      return (
                        <option value={category?.id} key={index}>
                          {category?.process_group_name}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col> */}
              <Col span={6}>
                <FormItem
                  label="Process"
                  name="prodlabel_process_id"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Process"
                    disabled={params.get('id') ? dataId : data}
                    showSearch
                    optionFilterProp="children"
                    // onChange={onChangeprocess}
                    onSearch={onSearch}
                  >
                    {processes?.map((category, index) => {
                      return (
                        <option value={category?.id} key={index}>
                          {category?.process_label_name}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Stage"
                  name="prodlabel_stage_id"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Stage"
                    disabled={params.get('id') ? dataId : data}
                    showSearch
                    optionFilterProp="children"
                    // onChange={onChangestage}
                    onSearch={onSearch}
                  >
                    {stageData?.map((category, index) => {
                      return (
                        <option value={category?.id} key={index}>
                          {category?.prodlabel_stage_name}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Next Stage"
                  name="prodlabel_nextstage_id"
                  rules={[
                    {
                      required: true,
                      message: 'Select Next Stage'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Next Stage"
                    disabled={params.get('id') ? !isHeaderEdit && dataId : data}
                    showSearch
                    optionFilterProp="children"
                    onSearch={onSearch}
                  >
                    {nextStageData?.map((category, index) => {
                      return (
                        <option value={category?.id} key={index}>
                          {category?.prodlabel_nextstage}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>

              <Col span={6}>
                <FormItem
                  label="No of Containers"
                  name="no_of_containers"
                  rules={[
                    {
                      required: true,
                      message: 'Select Product Batch'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select No of Containers"
                    disabled={params.get('id') ? dataId : data}
                    showSearch
                  >
                    {Array.from({ length: 301 }, (_, i) => i).map((i) => {
                      return (
                        <option value={i} key={i}>
                          {i}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={6}>
                <FormItem
                  label="Hold time"
                  name="hold_time"
                  rules={[
                    {
                      required: false,
                      message: 'Select Hold time'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <DatePicker
                    style={{
                      width: '100%'
                    }}
                    disabled={params.get('id') && !isHeaderEdit}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Batch size"
                  name="batch_size"
                  rules={[
                    {
                      required: true,
                      message: 'Enter batch size'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Input
                    placeholder=""
                    value=""
                    // disabled={params.get('id') ? dataId : data}
                    disabled={params.get('id') || !isCompression}
                  />
                </FormItem>
              </Col>
              <Col span={6}>
                <FormItem
                  label="Lot number"
                  name="lot_no"
                  rules={[
                    {
                      required: true,
                      message: 'Select Lot number'
                    }
                  ]}
                  className={styles.customLable}
                >
                  <Select
                    placeholder="Select Lot number"
                    showSearch
                    disabled={params.get('id') && !isHeaderEdit}
                  >
                    {Array.from({ length: 11 }, (_, i) => i).map((i) => {
                      return (
                        <option value={i} key={i}>
                          {i == 0 ? 'NA' : `Lot ${i}`}
                        </option>
                      );
                    })}
                  </Select>
                </FormItem>
              </Col>
            </Row>
            {params.get('id')
              ? !dataId
              : !data && (
                  <FormItem className="text-center">
                    <Space>
                      <CustomButton
                        className={styles.inwardButton}
                        htmlType="submit"
                        type="primary"
                        disabled={isCompression ? !showSubimt : false}
                      >
                        Proceed to Weighing
                      </CustomButton>
                      <CustomButton
                        className={styles.inwardButton}
                        type="primary"
                        ghost
                        onClick={() => history.back()}
                      >
                        Back
                      </CustomButton>
                    </Space>
                  </FormItem>
                )}
            {params.get('id') && isHeaderEdit && (
              <FormItem className="text-center">
                <Space>
                  {isHeaderDirty && (
                    <CustomButton
                      className={styles.inwardButton}
                      type="primary"
                      onClick={handleInitiateHeaderVerification}
                    >
                      Initiate Verification
                    </CustomButton>
                  )}
                  <CustomButton
                    className={styles.inwardButton}
                    type="primary"
                    ghost
                    onClick={handleCancelHeaderEdit}
                  >
                    Cancel
                  </CustomButton>
                </Space>
              </FormItem>
            )}
          </Form>
        </Card>
        {showNextCard && (
          <Card
            title="Weighing Details"
            className={`${styles.cardStyles_approver}`}
          >
            <Form form={form1} layout="vertical" onFinish={onFinish1}>
              <Row gutter={24}>
                <Col xs={4} xl={2} span={2} md={2} sm={2}>
                  <CustomButton
                    // onClick={() =>
                    //   setData({
                    //     index
                    //   })
                    // }
                    className={styles.qrcode}
                  >
                    <QrcodeOutlined onClick={() => setOpenCam(true)} />
                  </CustomButton>
                </Col>
                <Col span={8}>
                  {params.get('id') || ipAddress ? (
                    <FormItem
                      label="Weighing Balance"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        disabled
                        value={weighing_balance_id?.[0]?.balance_name}
                      />
                    </FormItem>
                  ) : (
                    <FormItem
                      label="Weighing Balance"
                      name="weighing_balance"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Select
                        placeholder="Select Weighing Balance"
                        onChange={(e) => handleBalance(e)}
                      >
                        {dispenseBooths?.map((item, index) => {
                          return (
                            <option value={item?.ip_address} key={index}>
                              {item?.balance_name}
                            </option>
                          );
                        })}
                      </Select>
                    </FormItem>
                  )}
                </Col>
                <Col span={8}>
                  <FormItem
                    label="Performed By"
                    rules={[
                      {
                        required: false,
                        message: 'Select Product name'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      placeholder=""
                      value={
                        prodLabels?.[0]?.performed_by
                          ? prodLabels[0].performed_by
                          : `${user?.employee} ( ${moment().format(
                              'YYYY-MM-DD'
                            )})`
                      }
                      disabled
                    />
                  </FormItem>
                </Col>
              </Row>
              {/* {Array.from({ length: 5 }, (_, i) => i).map((i) => {
                return ( */}
              {console.log(prodLabels)}
              {prodLabels?.length > 0
                ? prodLabels?.map((item, index) => {
                    return (
                      <Row gutter={24} key={index}>
                        <Col span={5}>
                          <FormItem
                            label="Container ID"
                            className={styles.customLable}
                          >
                            <Input
                              placeholder=""
                              value={item?.prod_containers}
                              disabled
                            />
                          </FormItem>
                        </Col>
                        <Col span={5}>
                          <FormItem
                            label="Tare Weight"
                            rules={[
                              {
                                required: true,
                                message: 'Select Product Batch'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            {editingContainer === item.id ? (
                              <>
                                <Input
                                  placeholder="Tare Weight"
                                  value={editWeights.tareWeight}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setEditWeights((prev) => ({
                                      ...prev,
                                      tareWeight: value
                                    }));
                                    setTareWeight(value);
                                  }}
                                />
                                <CustomButton
                                  style={{
                                    color: '#c91761',
                                    marginTop: '2px'
                                  }}
                                  size={'small'}
                                  onClick={() =>
                                    handleDispenseBooth('tare_weight', item.id)
                                  }
                                >
                                  Read
                                </CustomButton>
                              </>
                            ) : !item?.tare_Wt ? (
                              <>
                                <Input
                                  placeholder="Tare Weight"
                                  value={
                                    index === prodLabels.length - 1 &&
                                    !editingContainer
                                      ? tareWeight
                                      : ''
                                  }
                                  onChange={(e) =>
                                    setTareWeight(e.target.value)
                                  }
                                />
                                <CustomButton
                                  style={{
                                    color: '#c91761',
                                    marginTop: '2px'
                                  }}
                                  size={'small'}
                                  onClick={() =>
                                    handleDispenseBooth('tare_weight')
                                  }
                                >
                                  Read
                                </CustomButton>
                              </>
                            ) : (
                              <>
                                <Input
                                  placeholder="Tare Weight"
                                  value={item?.tare_Wt}
                                  disabled
                                />
                              </>
                            )}
                          </FormItem>
                        </Col>
                        <Col span={5}>
                          <FormItem
                            label="Net Weight"
                            rules={[
                              {
                                required: true,
                                message: 'Select Product Batch'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            {editingContainer === item.id ? (
                              <>
                                <Input
                                  placeholder="Net Weight"
                                  value={editWeights.netWeight}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setEditWeights((prev) => ({
                                      ...prev,
                                      netWeight: value
                                    }));
                                    setNetWeight(value);
                                  }}
                                />
                                <CustomButton
                                  style={{
                                    color: '#c91761',
                                    marginTop: '2px'
                                  }}
                                  size={'small'}
                                  onClick={() =>
                                    handleDispenseBooth('net_weight', item.id)
                                  }
                                >
                                  Read
                                </CustomButton>
                              </>
                            ) : !item?.net_Wt ? (
                              <>
                                <Input
                                  placeholder="Net Weight"
                                  value={
                                    index === prodLabels.length - 1 &&
                                    !editingContainer
                                      ? netWeight
                                      : ''
                                  }
                                  onChange={(e) => setNetWeight(e.target.value)}
                                />
                                <CustomButton
                                  style={{
                                    color: '#c91761',
                                    marginTop: '2px'
                                  }}
                                  size={'small'}
                                  onClick={() =>
                                    handleDispenseBooth('net_weight')
                                  }
                                >
                                  Read
                                </CustomButton>
                              </>
                            ) : (
                              <Input
                                placeholder="Net Weight"
                                value={item?.net_Wt}
                                disabled
                              />
                            )}
                          </FormItem>
                        </Col>
                        <Col span={5}>
                          <FormItem
                            label="Gross Weight"
                            // name="gross_weight"
                            rules={[
                              {
                                required: false,
                                message: 'Select Product Batch'
                              }
                            ]}
                            className={styles.customLable}
                          >
                            <Input
                              placeholder="Gross Weight"
                              value={
                                (editingContainer === item.id
                                  ? compute_gross_weight(
                                      editWeights.tareWeight,
                                      editWeights.netWeight
                                    )
                                  : item?.tare_Wt || item?.net_Wt
                                  ? // Saved rows show the stored value so the
                                    // screen matches the printed label; legacy
                                    // rows were rounded to 2 decimals and would
                                    // not survive a recompute.
                                    item?.gross_weight ||
                                    compute_gross_weight(
                                      item?.tare_Wt,
                                      item?.net_Wt
                                    )
                                  : index === prodLabels.length - 1 &&
                                    !editingContainer
                                  ? compute_gross_weight(tareWeight, netWeight)
                                  : '') || '0.00'
                              }
                              disabled
                            />
                          </FormItem>
                        </Col>

                        <Col span={4}>
                          <FormItem
                            className="text-center"
                            style={{ marginTop: '28px' }}
                          >
                            {editingContainer === item.id ? (
                              <CustomButton
                                className={styles.inwardButton}
                                type="primary"
                                disabled={
                                  !editWeights.tareWeight ||
                                  !editWeights.netWeight
                                }
                                onClick={() => handleInitiateWeightQA(item.id)}
                              >
                                Verify QA
                              </CustomButton>
                            ) : !item?.net_Wt ? (
                              submittingContainerId === item.id ? (
                                <Spin />
                              ) : (
                                <CustomButton
                                  className={styles.inwardButton}
                                  htmlType="submit"
                                  type="primary"
                                  onClick={() => {
                                    setContainerId(item.id);
                                  }}
                                >
                                  Print & Add
                                </CustomButton>
                              )
                            ) : (
                              <Space>
                                <Tooltip title="Download Label PDF">
                                  <CustomButton
                                    className={styles.inwardButton}
                                    type="primary"
                                    loading={regeneratingLabelId === item.id}
                                    disabled={
                                      regeneratingLabelId !== null &&
                                      regeneratingLabelId !== item.id
                                    }
                                    onClick={() =>
                                      handleRegenerateLabelPdf(item.id)
                                    }
                                  >
                                    <CloudDownloadOutlined />
                                  </CustomButton>
                                </Tooltip>
                                {params.get('id') && (
                                  <Tooltip title="Edit Weights">
                                    <CustomButton
                                      className={styles.inwardButton}
                                      type="primary"
                                      onClick={() => handleEdit(item.id)}
                                    >
                                      <EditOutlined />
                                    </CustomButton>
                                  </Tooltip>
                                )}
                              </Space>
                            )}
                          </FormItem>
                        </Col>
                      </Row>
                    );
                  })
                : ''}
              {console.log(prodLabels?.length, dataId?.[0]?.no_of_containers)}
              {prodLabels?.length <
              (data?.no_of_containers || dataId?.[0]?.no_of_containers) ? (
                <Row gutter={24}>
                  <Col span={5}>
                    <FormItem
                      label="Container ID"
                      name=""
                      rules={[
                        {
                          required: false,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input placeholder="" value="" disabled />
                    </FormItem>
                  </Col>
                  <Col span={5}>
                    <FormItem
                      label="Tare Weight"
                      // name="tare_Wt"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Tare Weight"
                        value={editingContainer ? '' : tareWeight}
                        onChange={(e) => setTareWeight(e.target.value)}
                        disabled={!!editingContainer}
                      />
                      <CustomButton
                        style={{
                          color: '#c91761',
                          marginTop: '2px'
                        }}
                        size={'small'}
                        onClick={() => handleDispenseBooth('tare_weight')}
                        disabled={!!editingContainer}
                      >
                        Read
                      </CustomButton>
                    </FormItem>
                  </Col>
                  <Col span={5}>
                    <FormItem
                      label="Net Weight"
                      // name="net_Wt"
                      rules={[
                        {
                          required: true,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Net Weight"
                        value={editingContainer ? '' : netWeight}
                        onChange={(e) => setNetWeight(e.target.value)}
                        disabled={!!editingContainer}
                      />
                      <CustomButton
                        style={{
                          color: '#c91761',
                          marginTop: '2px'
                        }}
                        size={'small'}
                        onClick={() => handleDispenseBooth('net_weight')}
                        disabled={!!editingContainer}
                      >
                        Read
                      </CustomButton>
                    </FormItem>
                  </Col>
                  <Col span={5}>
                    <FormItem
                      label="Gross Weight"
                      // name="gross_weight"
                      rules={[
                        {
                          required: false,
                          message: 'Select Product Batch'
                        }
                      ]}
                      className={styles.customLable}
                    >
                      <Input
                        placeholder="Gross Weight"
                        value={
                          editingContainer
                            ? '0.00'
                            : compute_gross_weight(tareWeight, netWeight) ||
                              '0.00'
                        }
                        disabled
                      />
                    </FormItem>
                  </Col>
                  <Col span={4}>
                    <FormItem
                      className="text-center"
                      style={{ marginTop: '28px' }}
                    >
                      <Space>
                        {submittingContainerId === 'new' ? (
                          <Spin />
                        ) : (
                          <CustomButton
                            className={styles.inwardButton}
                            htmlType="submit"
                            type="primary"
                            disabled={
                              editingContainer || !tareWeight || !netWeight
                            }
                            onClick={() => {
                              setContainerId('');
                            }}
                          >
                            Print & Add
                          </CustomButton>
                        )}
                      </Space>
                    </FormItem>
                  </Col>
                </Row>
              ) : (
                ''
              )}
              {/* <Col span={4}> */}
              <FormItem className="text-center" style={{ marginTop: '28px' }}>
                <Space>
                  {params.get('id') && (
                    <Tooltip title="Download Weighing Report">
                      <CustomButton
                        className={styles.inwardButton}
                        type="primary"
                        onClick={() => handleDownloadPdf(params.get('id'))}
                      >
                        <CloudDownloadOutlined />
                      </CustomButton>
                    </Tooltip>
                  )}
                  <CustomButton
                    className={styles.inwardButton}
                    onClick={() => history.back()}
                    type="primary"
                  >
                    Back
                  </CustomButton>
                </Space>
              </FormItem>
              {/* </Col> */}
              {/* );
              })} */}
              <Modal
                title="Scan QR Code"
                visible={openCam}
                onCancel={() => setOpenCam(false)}
                footer={null}
                destroyOnClose
                centered
                width={420}
              >
                {openCam && (
                  <QrReader
                    constraints={{
                      facingMode: 'environment'
                    }}
                    delay={300}
                    onError={handleError}
                    onResult={(result) => handleQrScan(result)}
                    style={{
                      width: '100%',
                      height: 'auto'
                    }}
                  />
                )}
              </Modal>
            </Form>
          </Card>
        )}
      </Layout>
      {isQAModal && (
        <VerificationModal
          isModal={isQAModal}
          setIsModal={setIsQAModal}
          material={pendingHeaderUpdate}
          setIsEdit={setIsHeaderEdit}
          page="prod_label_update"
        />
      )}
      {isWeightQAModal && (
        <VerificationModal
          isModal={isWeightQAModal}
          setIsModal={setIsWeightQAModal}
          material={pendingWeightUpdate}
          setIsEdit={(v) => {
            if (!v) {
              setEditingContainer(null);
              setContainerId('');
              setEditWeights({ tareWeight: '', netWeight: '' });
            }
          }}
          page="prod_label_weight_update"
        />
      )}
    </>
  );
};
export default CreateProductLabel;
